const log = require('../shared_utils/log.js')
const { getTargetAtClientPosition } = require('../shared_utils/coordinates.js')
const { findTargetById } = require('../shared_utils/find-target.js')
module.exports = function store(state, emitter) {
  emitter.on('click-on-game', e => {
    log('click-on-game', e)
    state.showLevelsPanel = false
    if (e.target === state.canvas ) {
      let clickTarget = getTargetAtClientPosition(
        e.clientX,
        e.clientY,
        state.vm
      )
      if (state.isFullscreen && clickTarget){
        const v = state.projectMetadata.exposedVariables.find(v => v.spriteName === clickTarget.sprite.name)
        if (!v){
          clickTarget = null
        }
      }
      if (clickTarget) {
        if (state.selectedVariableId) {
          emitter.emit('set-selected-sprite-variable', clickTarget)
        } else {
          emitter.emit('select-target', clickTarget.id)
          emitter.emit('start-moving-target', e)
          emitter.emit('render')
        }
      } else {
        emitter.emit('deselect-target')
      }
    }
  })

  emitter.on('select-target', targetId => {

    console.log('select-target', targetId)
    const target = findTargetById(state.vm, targetId)
    if (!target) {
      return
    }
    
    // Sprite selection logic from first handler
    emitter.emit("select-sprite", target.sprite.name)
    state.currentVariablePage = 0

    // Reset selections from first handler
    state.selectedGlitchApplicationId = null
    state.selectedGlitchId = null
    state.selectedPartId = null
    state.selectedVariableId = null
    state.currentVariablePage = 0

    // Set target ID and handle glitch selection from second handler
    state.selectedTargetId = targetId
    console.log('selected target id', state.selectedTargetId)
    emitter.emit('render')
    if (targetId && !state.playingTutorial) {
      // First check if we have a previously selected glitch for this target
      const lastSelectedGlitchId = state.lastSelectedGlitchApplicationIds[targetId];
      
      // Find all non-physics glitches applied to this target
      const appliedGlitches = state.glitchApplications.filter(
        g => g.targetId === targetId && g.glitchId !== 'builtin_physics'
      );

      if (lastSelectedGlitchId && appliedGlitches.find(g => g.id === lastSelectedGlitchId)) {
        // If last selected glitch still exists, select it
        emitter.emit('select-glitch-application', lastSelectedGlitchId);
      } else if (appliedGlitches.length > 0) {
        // If last selected glitch was deleted or doesn't exist, select the last applied glitch
        emitter.emit('select-glitch-application', appliedGlitches[appliedGlitches.length - 1].id);
      } else {
        // If no non-physics glitches exist, clear the glitch selection
        emitter.emit('select-glitch-application', null);
      }
    } 

    emitter.emit('render')
  })

  emitter.on('deselect-target', () => {
    log('deselect-target')
    state.selectedGlitchApplicationId = null
    state.selectedVariableId = null
    state.settingSpriteVariable = false
    state.selectedTargetId = null
    emitter.emit('render')
  })

}
